import { 
  createContext, 
  useContext 
} from 'react';

import { useMRTableModals } from '../hooks/useMRTableModals';

const MRTableModalsContext = createContext(null);

const MRTableModalsProvider = ({children}) => {
  const modalState = useMRTableModals();
  return (
    <MRTableModalsContext.Provider value={modalState}>
      {children}
    </MRTableModalsContext.Provider>
  );
};

const useMRTableModalsContext = () => {
  const context = useContext(MRTableModalsContext);
  if (!context) {
    throw new Error('useMRTableModalsContext must be used within MRTableModalsProvider');
  }
  return context;
};

export {MRTableModalsProvider, useMRTableModalsContext}